import { ExternalLink } from 'lucide-react';
import { useMemo } from 'react';

import IconButton from '@/components/Button/IconButton';
import {
  BaseTable,
  type RowData,
  type TableColumnT,
} from '@/features/Product/components/BaseTable';
import { JobStatus } from '@/features/Setting/Integrations/components/JobStatus/JobStatus';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

import type { DuplicatedScrapingJob } from '../../api';
import { ScrapingJobStatusToDisplayStatus } from '../../types';

export const DuplicatedJobTable = ({
  data,
  onExternalLinkClick,
}: {
  data: DuplicatedScrapingJob[];
  onExternalLinkClick: (jobId: string) => void;
}) => {
  const columns: TableColumnT<DuplicatedScrapingJob>[] = useMemo(() => {
    return [
      {
        columnKey: 'title',
        Header: 'Title',
        Cell: (row: RowData<DuplicatedScrapingJob>) => {
          return (
            <div>
              {row.rowData.title}
              <IconButton
                outlined={false}
                icon={<ExternalLink className="size-3.5" />}
                onClick={() => {
                  onExternalLinkClick(row.rowData.alias);
                }}
                className="translate-y-0.5"
              />
            </div>
          );
        },
        className: 'flex-40',
      },
      {
        columnKey: 'status',
        Header: 'Status',
        Cell: (row: RowData<DuplicatedScrapingJob>) => {
          return (
            <JobStatus
              status={ScrapingJobStatusToDisplayStatus.get(row.rowData.status)}
            />
          );
        },
        className: 'flex-40',
      },
      {
        columnKey: 'feedback_count',
        Header: 'Feedback count',
        Cell: (row: RowData<DuplicatedScrapingJob>) => {
          return <div>{row.rowData.feedback_count}</div>;
        },
        className: 'flex-40',
      },
      {
        columnKey: 'date_range',
        Header: 'Date range',
        Cell: (row: RowData<DuplicatedScrapingJob>) => {
          return (
            <div>
              {getTimezoneDayjs(row.rowData.start_date).format(
                DATE_FORMAT.short,
              )}{' '}
              -{' '}
              {getTimezoneDayjs(row.rowData.end_date).format(DATE_FORMAT.short)}
            </div>
          );
        },
        className: 'flex-40',
      },
    ];
  }, [onExternalLinkClick]);
  return (
    <div className="overflow-x-auto w-full">
      <BaseTable
        tableClassName="max-h-[350px] overflow-y-auto"
        columns={columns}
        data={data.map((item) => ({
          rowKey: item.alias,
          rowData: item,
        }))}
      />
    </div>
  );
};
